import './Table.scss';

const checkTableWidth = () => {
    const allTable = document.querySelectorAll('.copy-table');
    const allTableContainer = document.querySelectorAll('.copy-table__container');
    for (let i = 0; i < allTable.length; i++) {
        if (allTable[i].offsetWidth > allTableContainer[i].offsetWidth) {
            allTableContainer[i].classList.add('table-container--is-smaller');
        }
        else {
            allTableContainer[i].classList.remove('table-container--is-smaller');
        }
    }
    window.onresize = function () {
        checkTableWidth();
    };
};

checkTableWidth();